import CategoryListTemplate from "./category-list.template";
import { useState } from "react";
import { useEffect } from "react";
import { getCategoryDataApi } from "../Home-Page/home-page.component.service";
import { useNavigate } from "react-router-dom";

const CategoryListComponent = () => {
  const [categories, setCategories] = useState([]);
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const onLoad = async () => {
    setLoading(true);
    const response = await getCategoryDataApi();
    console.log({ response });

    if (response.status) {
      setCategories(response.data);
    }
    setLoading(false);
  };
  const handleViewDetails = (categoryId) => {
    console.log("View Details for Category ID:", categoryId);
    navigate(`/inventory/${categoryId}`);
  };
  useEffect(() => {
    onLoad();
  }, []);
  const templateData = {
    categories,
    loading,
  };
  const templateEvent = {
    onLoad,
    handleViewDetails,
  };
  return (
    <CategoryListTemplate
      templateData={templateData}
      templateEvent={templateEvent}
    />
  );
};

export default CategoryListComponent;
